import AlternativeItineraryMutationProvider from './AlternativeItineraryMutationProvider';
export { useAlternativeItineraryMutation } from './AlternativeItineraryMutationProvider';
export default AlternativeItineraryMutationProvider;
